import Timeline from "../Timeline";

import { ModalBody, Spinner } from "reactstrap";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";

import { contractDeployStages as stages } from "../../constants";

const ContractModal = ({ show, stage, error }) => {
    const getData = () => {
        const nStage = stages.findIndex(
            (stageItem) => stageItem.name === stage
        );

        return stages.map((stageItem, i) => {
            const newStage = { ...stageItem };

            if (stage === "done") {
                newStage.color = "success";
            } else {
                if (i < nStage) {
                    newStage.color = "success";
                }

                if (i > nStage) {
                    newStage.className = "timeline-item-pending";
                    newStage.color = "dark";
                }

                if (i === nStage) {
                    if (error) {
                        newStage.color = "danger";
                        newStage.content = error.message;
                        newStage.meta = null;
                    } else {
                        newStage.meta = <Spinner />;
                        newStage.color = "warning";
                    }
                }
            }

            return newStage;
        });
    };

    return (
        <Dialog open={show} disableEscapeKeyDown fullWidth maxWidth="md">
            <ModalBody className="px-sm-4 mx-50 py-4">
                <DialogTitle>Deploying Contract</DialogTitle>
                <Timeline className="ms-50 mb-0 mt-4" data={getData()} />
            </ModalBody>
        </Dialog>
    );
};

export default ContractModal;
